import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export default function LinearProgressWithLabel(props) {
  const { value, max, showValue, ...other } = props;

  const normalize = (value, min, max) => (value - min) * 100 / (max - min);

  const getDisplayValue = () => {
    if (showValue) {
      return value;
    }
    if (max) {
      return `${value}/${max}`;
    }
    return `${Math.round(value)}%`;
  };

  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" value={normalize(value, 0, max)} {...other} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary" style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
          {getDisplayValue()}
        </Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
  /**
   * The maximum value for the progress indicator.
   * When provided, displays value/max instead of percentage.
   */
  max: PropTypes.number,
  /**
   * When true, displays the raw value instead of percentage.
   */
  showValue: PropTypes.bool,
};
